import { gqlClient } from '.';

interface Variables {
  preview?: boolean;
  [key: string]: string | number | boolean | undefined;
}

export const gqlQuery = (query: string, variables?: Variables) =>
  gqlClient(variables?.preview).request(query, variables);
